export default __webpack_public_path__ + "static/media/NEX_Present-Draft_02 (Lowres).454e62be.mp4";